exports = module.exports = require("./../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content-row{padding:2em 4em}.bfm-link{display:inline-block;color:#252525;text-decoration:none;-webkit-transition:all .3s ease-in;transition:all .3s ease-in}.bfm-link:hover{color:#6c6c6c}button[disabled],button[disabled]:active,button[disabled]:hover{background:#ccc;border-color:#ccc;text-shadow:none;cursor:auto}.clearfix:after{content:\" \";display:block;clear:both}@media(max-width:849px){.content-row{padding:2em .5em}}@media(max-width:1000px){.content-row{padding:2em}}.areas-area__wrapper.areas-area__wrapper--hero.areas-area__wrapper--probate{background-color:#6c6c6c;color:#fff}.areas-area__wrapper.areas-area__wrapper--hero.areas-area__wrapper--probate .areas-area__hero{background:url(" + require("../../../../../assets/images/areas/areas-probate.jpg") + ") no-repeat 50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoaders=1!./~/postcss-loader!./app/screens/App/screens/Areas/styles/area-probate.css
// module id = 92
// module chunks = 0